import { createSelector } from "reselect";
import { woundAssessmentProgressChartDataSelector } from "../wound_assessment_progress_chart_data_selector";

export const woundAssessmentProgressChartDataDataSelector = createSelector(
  woundAssessmentProgressChartDataSelector,
  chartData => chartData.data
);
